import React from 'react';
import { User } from '../../../../../../models/interfaces/User.interface';
import { Link, useOutletContext, useParams } from 'react-router-dom';
import { Product } from '../../../../../../models/interfaces/Product.interface';
import ProductFormComponent from '../../components/product-form/product-form.component';
import { BusinessObject } from '../../../../../../models/interfaces/BusinessObject.interface';
import { ProductCategory } from '../../../../../../models/interfaces/ProductCategory.interface';
import businessObjectService from '../../../../../../services/business-object.service';
import routeService from '../../../../../../routes/route.service';

export default function ProductDetailComponent() {
  const { user, businessObject, category } = useOutletContext<{
    user: User;
    businessObject: BusinessObject;
    category: ProductCategory;
  }>();
  const { productId } = useParams();

  const [product, setProduct] = React.useState<Product>(null);

  React.useEffect(() => {
    const getProduct = async (userEmail: string, boId: number, categoryId: number, productId: number) => {
      const data = await businessObjectService.getProductById(userEmail, boId, categoryId, productId);
      setProduct(data);
    };

    if (user?.email && businessObject?.id && category?.id && productId) {
      getProduct(user?.email, businessObject?.id, category?.id, Number(productId));
    }
  }, [user, businessObject, category, productId]);

  return (
    <div>
      <ProductFormComponent
        ownerId={user?.id}
        businessObjectId={businessObject?.id}
        categoryId={category?.id}
        product={product}
      />

      <div>
        <Link to={routeService.getAndFillCategoryDetailPath(user?.id, businessObject?.id, category?.id)}>
          Back to category
        </Link>
      </div>
    </div>
  );
}
